const gurgaonWeddingLarge = [
    {
        _id: '1',
        value: {
            sub_area: 'old-gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Old Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '2',
        value: {
            sub_area: 'sohna-road',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Sohna Road',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '3',
        value: {
            sub_area: 'manesar',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Manesar',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '4',
        value: {
            sub_area: 'nh8/bijwasan/aerocity',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'NH8/Bijwasan/Aerocity',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '5',
        value: {
            sub_area: 'chattarpur',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'Chattarpur',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const gurgaonWeddingSmall = [
    {
        _id: '6',
        value: {
            sub_area: 'dlf-cyber-city',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'DLF Cyber City',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '7',
        value: {
            sub_area: 'mg-road',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'MG Road',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '8',
        value: {
            sub_area: 'golf-course-road',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Golf Course Road',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '9',
        value: {
            sub_area: 'golf-course-extension-road',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Golf Course Extension Road',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '10',
        value: {
            sub_area: 'sohna-road',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Sohna Road',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '11',
        value: {
            sub_area: 'sector-29',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Sector 29',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '12',
        value: {
            sub_area: 'manesar',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Manesar',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '13',
        value: {
            sub_area: 'old-gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Old Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '14',
        value: {
            sub_area: 'udyog-vihar',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Udyog Vihar',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const southDelhi = [
    {
        _id: '15',
        value: {
            sub_area: 'chattarpur',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'Chattarpur',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '16',
        value: {
            sub_area: 'nh-8',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'Nh-8',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '17',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '18',
        value: {
            sub_area: 'faridabad',
            region: 'faridabad',
            city: 'faridabad',
        },
        label: 'Faridabad',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const   eastDelhi = [
    {
        _id: '19',
        value: {
            sub_area: 'south-delhi',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'South Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '20',
        value: {
            sub_area: 'ghaziabad',
            region: 'ghaziabad',
            city: 'delhi',
        },
        label: 'Ghaziabad',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '21',
        value: {
            sub_area: 'noida',
            region: 'noida',
            city: 'noida',
        },
        label: 'Noida',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '22',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const noida = [
    {
        _id: '23',
        value: {
            sub_area: 'ghaziabad',
            region: 'ghaziabad',
            city: 'ghaziabad',
        },
        label: 'Ghaziabad',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '24',
        value: {
            sub_area: 'east-delhi',
            region: 'east-delhi',
            city: 'delhi',
        },
        label: 'East Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '25',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const ghaziabad = [
    {
        _id: '26',
        value: {
            sub_area: 'noida',
            region: 'noida',
            city: 'noida',
        },
        label: 'Noida',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '27',
        value: {
            sub_area: 'east-delhi',
            region: 'east-delhi',
            city: 'delhi',
        },
        label: 'East Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const faridabad = [
    {
        _id: '28',
        value: {
            sub_area: 'old-faridabad',
            region: 'faridabad',
            city: 'faridabad',
        },
        label: 'Old Faridabad',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '29',
        value: {
            sub_area: 'surajkund',
            region: 'faridabad',
            city: 'faridabad',
        },
        label: 'Surajkund',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '30',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '31',
        value: {
            sub_area: 'south-delhi',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'South Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const westDelhi = [
    {
        _id: '32',
        value: {
            sub_area: 'south-delhi',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'South Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '33',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '34',
        value: {
            sub_area: 'noida',
            region: 'noida',
            city: 'noida',
        },
        label: 'Noida',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const northDelhi = [
    {
        _id: '35',
        value: {
            sub_area: 'south-delhi',
            region: 'south-delhi',
            city: 'delhi',
        },
        label: 'South Delhi',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '36',
        value: {
            sub_area: 'gurgaon',
            region: 'gurgaon',
            city: 'gurgaon',
        },
        label: 'Gurgaon',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '37',
        value: {
            sub_area: 'noida',
            region: 'noida',
            city: 'noida',
        },
        label: 'Noida',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const mumbai = [
    {
        _id: '23',
        value: {
            sub_area: 'navi-mumbai',
            region: 'navi-mumbai',
            city: 'mumbai',
        },
        label: 'Navi Mumbai',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '24',
        value: {
            sub_area: 'thane',
            region: 'thane',
            city: 'mumbai',
        },
        label: 'Thane',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '25',
        value: {
            sub_area: 'central-suburbs',
            region: 'central-suburbs',
            city: 'mumbai',
        },
        label: 'Central Suburbs',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '26',
        value: {
            sub_area: 'western-suburbs',
            region: 'western-suburbs',
            city: 'mumbai',
        },
        label: 'Western Suburbs',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '27',
        value: {
            sub_area: 'south-mumbai',
            region: 'south-mumbai',
            city: 'mumbai',
        },
        label: 'South Mumbai',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

const pune = [
    {
        _id: '23',
        value: {
            sub_area: 'navi-mumbai',
            region: 'navi-mumbai',
            city: 'mumbai',
        },
        label: 'Navi Mumbai',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '24',
        value: {
            sub_area: 'thane',
            region: 'thane',
            city: 'mumbai',
        },
        label: 'Thane',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '25',
        value: {
            sub_area: 'central-suburbs',
            region: 'central-suburbs',
            city: 'mumbai',
        },
        label: 'Central Suburbs',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '26',
        value: {
            sub_area: 'western-suburbs',
            region: 'western-suburbs',
            city: 'mumbai',
        },
        label: 'Western Suburbs',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
    {
        _id: '27',
        value: {
            sub_area: 'south-mumbai',
            region: 'south-mumbai',
            city: 'mumbai',
        },
        label: 'South Mumbai',
        isImageAvailable: false,
        image: '',
        image_alt_text: '',
        targetKey: 0,
    },
];

module.exports = {
    gurgaonWeddingLarge,
    gurgaonWeddingSmall,
    southDelhi,
    eastDelhi,
    noida,
    ghaziabad,
    faridabad,
    westDelhi,
    northDelhi,
    mumbai,
    pune,
};
